import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { UserLoginRequest } from '../model/user/user-login-request';
import { UserLoginResponse } from '../model/user/user-login-response';
import { AplatzLocationRequest } from '../model/wo/aplatz/aplatz-location-requet';
import { WorderService } from './worder.service';
// import FingerprintJS from '@fingerprintjs/fingerprintjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {


  constructor(@Inject('apiUrl') private readonly apiUrl, private readonly http: HttpClient, public router: Router, private readonly worderService: WorderService) { 
   
  }
  //#region  Header
  // private accesstoken = localStorage.getItem('accessToken');
  // private token_type = localStorage.getItem('token_type');
  // private authorization = this.token_type + ' ' + this.accesstoken;


  private requestOptions = new HttpHeaders({
    'Content-Type': 'application/json',

    // 'application/x-www-form-urlencoded',Authorization: this.authorization

  });

  ok = false;
  private options = { headers: this.requestOptions };
  //#endregion
  logOut(UserId: any)
  {
   const requestOptions = this.newMethod();
   const url: string = this.apiUrl + '/api/Account/DeleteUser?UserId=' + UserId;
   return this.http.get<any>(url, { headers : requestOptions} );
  }
  login(userloginrequest: any): Observable<any> {

    const url: string = this.apiUrl + '/api/User/BeasSign';
    const user = userloginrequest;
    return this.http.post<any>(url, user, this.options);
  }

   // Sign-in
   onSignIn(user: any) {

    const url: string = this.apiUrl + '/token';
    const header = new Headers();
   
     header.append(
      'content-type',
       'application/x-www-form-urlencoded; charset=utf-8',
 
     );
     

    const tokendata =
      'grant_type=password&username=' + user.username + '&password=' + user.password;
    const headers = new HttpHeaders().set('content-type', 'application/x-www-form-urlencoded; charset=utf-8');
    return this.http.post<any>(url, tokendata, { headers });

  }

  isLoggedIn(): boolean {

    const authToken = localStorage.getItem('userId');

    this.ok = (authToken !== null) ? true : false;
    if (this.ok){
      const xx = new AplatzLocationRequest();
      xx.PersonnelCode = authToken;
      const apltz = localStorage.getItem('aplatzId');
      // if (apltz == null){
        this.worderService.postAplatzDefault(xx).subscribe((apltx: any) => {
          localStorage.setItem('aplatzId', apltx.Result.AblatzId);
          if (apltx.Result.Status == 1){
            this.ok = true;
          }
          else{
            this.ok = false;
          }
        });

        // Personelin Son Çalıştığı Tezgah
        // this.worderService.postAplatzLast(xx).subscribe((apltx:any)=>{

        //   if(apltx.Result.value.length == 0){
        //     this.worderService.postAplatzDefault(xx).subscribe((apltx:any)=>{
        //       localStorage.setItem('aplatzId', apltx.Result.AblatzId);
        //       if(apltx.Result.Status==1){
        //         this.ok=true;
        //       }
        //       else{
        //         this.ok=false;
        //       }
        //     });
        //   }
        //   else{
        //     localStorage.setItem('aplatzId', apltx.Result.value[0].ResourceId);
        //   }
        // });
      }

    //}

    return this.ok;
  }

  isLogged(): boolean {
    const authToken = localStorage.getItem('accessToken');
    return (authToken !== null) ? this.ok = true : this.ok = false;
  }

  onExit(){
    localStorage.removeItem('accessToken');
    localStorage.removeItem('userId');
    localStorage.removeItem('userName');
    localStorage.removeItem('token_type');
    localStorage.removeItem('aplatzId');
    this.ok = false;
    this.router.navigate(['/login']);
  }
  onGetGeneralParameter()
  {
    const requestOptions = this.newMethod();
    const url: string = this.apiUrl + '/api/IdentityConfig/GeneralParameter()';
    return this.http.get<any>(url, { headers : requestOptions} );
  }

  private newMethod() {
    const accesstoken = localStorage.getItem('accessToken');
    const token_type = localStorage.getItem('token_type');
    const authorization = token_type + ' ' + accesstoken;
    const requestOptions = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: authorization
    });
    return requestOptions;
  }
}
